<template>
<main>
    <research-component/>
</main>
</template>
<script>
import Research from '../views/Research'
  export default {
    name: "Legal",
    components:{
        'research-component': Research
    }
  }
</script>
<style scoped>
</style>
